export default __webpack_public_path__ + "static/media/AdFlights_07.8949bc28.png";